import { routes } from './routes.tsx'
import { createBrowserRouter } from 'react-router-dom'
import {
  dashboard,
  firmManagement,
  idea,
  myAchievements,
  overallRanking,
  rules,
  statistics,
  tickerManagement,
  userManagement,
} from './router-object.tsx'
import { LoginPage } from '../pages/login-page.tsx'
import { RouteGuard } from './router-guard.tsx'
import { IdeyaRoute } from './router.def.ts'
import { Disclaimer } from '../pages/disclaimer/disclaimer.tsx'
import { GlobalDisclaimer } from '../pages/disclaimer/global-disclaimer.tsx'
import { Logout } from '../pages/logout/logout.tsx'
import { Inactive } from '../pages/inactive/inactive.tsx'
import { Root } from '../common/layouts/root.tsx'
import { isIppon } from '../utils/helpers.ts'
import { Auth0Login } from '../1ppon/auth0-login.tsx'
import { IpponRoot } from '../common/layouts/ippon-root.tsx'

const wrapWithRouteGuard = (route: IdeyaRoute) => {
  return {
    ...route,
    element: <RouteGuard route={route}>{route.element}</RouteGuard>,
  }
}

export const remixRouter = createBrowserRouter([
  {
    path: routes.login,
    element: isIppon ? <Auth0Login /> : <LoginPage />,
    errorElement: <div>Error</div>,
  },
  {
    path: routes.logout,
    element: <Logout />,
    errorElement: <div>Error</div>,
  },
  {
    path: routes.disclaimer,
    element: <Disclaimer />,
    errorElement: <div>Error</div>,
  },
  {
    path: routes.globalDisclaimer,
    element: <GlobalDisclaimer />,
    errorElement: <div>Error</div>,
  },
  {
    path: routes.inactive,
    element: <Inactive />,
    errorElement: <div>Error</div>,
  },
  {
    path: '/',
    element: isIppon ? <IpponRoot/> : <Root />,
    errorElement: <div>Error page</div>,
    children: [
      wrapWithRouteGuard(dashboard),
      wrapWithRouteGuard(idea),
      wrapWithRouteGuard(overallRanking),
      wrapWithRouteGuard(myAchievements),
      wrapWithRouteGuard(statistics),
      wrapWithRouteGuard(firmManagement),
      wrapWithRouteGuard(userManagement),
      wrapWithRouteGuard(tickerManagement),
      wrapWithRouteGuard(rules),
    ],
  },
])
